export default __webpack_public_path__ + "static/media/complete_sura.0ec034c3.svg";